import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const MOCK_USER = {
  email: "admin@optikurve.com",
  name: "Admin",
  role: "Platform Administrator",
  avatar: "AK",
};

const VALID_CREDENTIALS = {
  email: "admin@optikurve.com",
  password: "admin123",
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("optikurve.user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (user) localStorage.setItem("optikurve.user", JSON.stringify(user));
    else localStorage.removeItem("optikurve.user");
  }, [user]);

  const login = async (email, password) => {
    await new Promise((r) => setTimeout(r, 600));
    if (
      email.trim().toLowerCase() === VALID_CREDENTIALS.email &&
      password === VALID_CREDENTIALS.password
    ) {
      setUser(MOCK_USER);
      return { ok: true };
    }
    return { ok: false, error: "Invalid credentials. Try admin@optikurve.com / admin123" };
  };

  const logout = () => setUser(null);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
